import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box } from '../box';
import { Input } from '../input';
import { Popover } from '../popover';
import { __DEV__ } from '../utils';
import { SelectProvider } from './context';
import SelectButton from './selectButton';
import SelectContent from './selectContent';
import SelectGroup from './selectGroup';
import SelectOption from './selectOption';
import useSelect from './useSelect';
/**
 * Wraps trigger and content elements, providing them with context.
 * When no children are provided, content can be displayed based on 'options' data prop.
 * Supports single select and multi select, as well as controlled and uncontrolled modes.
 */
export function Select(props) {
    const { children, defaultValue, disabled, isInvalid, isMultiple, maxHeight, name, onChange, options, placeholder = 'Please select', readOnly, selectButton, selectButtonProps, showOptionsFilter, size, value, variant, ...rest } = props;
    const selectProps = useSelect({ defaultValue, isMultiple, onChange, value, options, children });
    if (__DEV__ && isMultiple && !Array.isArray(selectProps.value)) {
        console.error('<Select /> is used with isMultiple but its value is not an array: ', value);
    }
    const [query, setQuery] = useState('');
    const [filteredOptions, setFilteredOptions] = useState(options);
    const context = {
        disabled,
        isInvalid,
        isMultiple,
        name,
        options,
        placeholder,
        readOnly,
        size,
        variant,
        ...selectProps
    };
    const onQueryChange = (e) => {
        setQuery(e.target.value?.toLowerCase());
    };
    const filterOptions = (i) => !showOptionsFilter || !query?.length ? true : i?.text?.toLowerCase()?.includes(query);
    useEffect(() => {
        setFilteredOptions(options?.filter(filterOptions));
    }, [query, options]);
    return (_jsx(SelectProvider, { value: context, children: _jsx(Popover, { matchWidth: true, ...rest, children: _jsxs(_Fragment, { children: [selectButton ?? _jsx(SelectButton, { ...selectButtonProps }), _jsxs(SelectContent, { children: [showOptionsFilter && (_jsx(Box, { mr: 2, children: _jsx(Input, { iconLeft: "culFilterAlt", m: 1, mt: 0, onChange: onQueryChange, placeholder: "Filter\u2026", size: "sm", value: query }) })), _jsx(SelectGroup, { maxH: maxHeight, tabIndex: 1000, children: children ??
                                    filteredOptions?.map?.(option => _jsx(SelectOption, { title: option.text, ...option }, option.value)) })] })] }) }) }));
}
Select.Button = SelectButton;
Select.Content = SelectContent;
Select.Group = SelectGroup;
Select.Option = SelectOption;
Select.displayName = 'Select';
export default Select;
